module.exports = __webpack_public_path__ + "img/meeting-icon.aebdc259.svg";